import { isEmpty } from 'lodash'

import { hasAnySim, isAllFilled, isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta05ExemplosEnum,
  ConsultaSeguimentoPergunta05Model,
} from './model-consultaSeguimentoPergunta05'

const pergunta05ExemplosEnumValues = Object.values(ConsultaSeguimentoPergunta05ExemplosEnum)
const pergunta05ExemplosFalhouEnumValues = [
  ConsultaSeguimentoPergunta05ExemplosEnum.MOVIMENTA_OS_DEDOS_PERTO_DOS_OLHOS,
  ConsultaSeguimentoPergunta05ExemplosEnum.MANTEM_AS_MAOS_ELEVADAS_PERTO_DOS_OLHOS,
  ConsultaSeguimentoPergunta05ExemplosEnum.MANTEM_AS_MAOS_AO_LADO_DOS_OLHOS,
  ConsultaSeguimentoPergunta05ExemplosEnum.AGITA_AS_MAOS_PERTO_DO_ROSTO,
]

export function isPergunta05ExemplosAllNao(value: ConsultaSeguimentoPergunta05Model['PERGUNTA_05_EXEMPLOS']): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllNao(allExemplos, pergunta05ExemplosEnumValues)
}

export function hasPergunta05ExemplosPassouAnySim(
  value: ConsultaSeguimentoPergunta05Model['PERGUNTA_05_EXEMPLOS']
): boolean {
  const exemplosPassou = value?.PASSOU ?? {}
  return !isEmpty(exemplosPassou) && hasAnySim(exemplosPassou)
}

export function hasPergunta05ExemplosFalhouAnySim(
  value: ConsultaSeguimentoPergunta05Model['PERGUNTA_05_EXEMPLOS']
): boolean {
  const exemplosFalhou = value?.FALHOU ?? {}
  return !isEmpty(exemplosFalhou) && hasAnySim(exemplosFalhou)
}

export function isPergunta05ExemplosFalhouAllNao(
  value: ConsultaSeguimentoPergunta05Model['PERGUNTA_05_EXEMPLOS']
): boolean {
  return isAllNao(value?.FALHOU, pergunta05ExemplosFalhouEnumValues)
}

export function isPergunta05ExemplosFalhouAllFilled(
  value: ConsultaSeguimentoPergunta05Model['PERGUNTA_05_EXEMPLOS']
): boolean {
  return isAllFilled(value?.FALHOU, pergunta05ExemplosFalhouEnumValues)
}
